export default __webpack_public_path__ + "static/media/Shaka_particle_final_03.2edd9c08.png";